export const data = [
	{
        name: "Early Birds",
        monthly_price: "9",
        yearly_price: "99",
        currency: "$",
        description: "The functional goal of technical content is to help people use a product successfully.",
        action: {
            name: "Purchase Now",
            url: "/"
        }
    },
    {
        name: "Team",
        monthly_price: "32",
        yearly_price: "199",
        currency: "$",
        description: "The functional goal of technical content is to help people use a product successfully.",
        action: {
            name: "Purchase Now",
            url: "/"
        }
    },
    {
        name: "Personal",
        monthly_price: "69",
        yearly_price: "999",
        currency: "$",
        description: "The functional goal of technical content is to help people use a product successfully.",
        action: {
            name: "Purchase Now",
            url: "/"
        }
	},
	{
        name: "Plutinum",
        monthly_price: "99",
        yearly_price: "1039",
        currency: "$",
        description: "The functional goal of technical content is to help people use a product successfully.",
        action: {
            name: "Purchase Now",
            url: "/"
        }
    }
]

export default data;